export default "__VITE_ASSET__BYhBRUcH__"